<template>
  <div class="home-product" ref="target">
    <ZhiYeLesson :sideImg="sideImg" />
    <ZhiChengLesson :sideImg="sideImg" />
    <GuiPeiLesson :sideImg="sideImg" />
    <SheBeiLesson :sideImg="sideImg" />
  </div>
</template>

<script>
import ZhiYeLesson from "./zhiye-lesson";
import ZhiChengLesson from "./zhicheng-lesson";
import SheBeiLesson from "./shebei-lesson";
import GuiPeiLesson from "./guipei-lesson";
import { findBanner } from "@/api/home";
import { useLazySideImg } from "@/hooks";
import { ref } from "vue";
export default {
  name: "HomeLesson",
  components: {
    ZhiYeLesson,
    SheBeiLesson,
    GuiPeiLesson,
    ZhiChengLesson,
  },
  setup() {
    const target = ref(null);
    //console.log(target);
    const { result } = useLazySideImg(target, () => findBanner(1733213917716));

    return { sideImg: result, target };
  },
};
</script>

<style scoped lang="less"></style>
